import { render, staticRenderFns } from "./BluetoothVersion.vue?vue&type=template&id=3ecc78ba&scoped=true"
import script from "./BluetoothVersion.vue?vue&type=script&lang=js"
export * from "./BluetoothVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc78ba",
  null
  
)

export default component.exports